/** @jsxImportSource @emotion/react */
import { useEffect, useState, useRef,useContext } from 'react';
import DialogTitle from './DialogTitle';
import { StyledTextField } from '../../../Components/CustomTextfield';
import { Grid, Button, useMediaQuery, DialogContent, useTheme, useEventCallback, Typography } from '@mui/material';
import classes from './style';
import { onFileSelection } from '../helper';
import { canvasPreview } from './CanvasPreview'
import { useDebounceEffect } from './useDebounceEffect'
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import ConfirmationPopup from "./ConfirmationPopup";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from '../../../Helper/Axios/interceptor';
import config from '../../../config';
import Dialog from "../../Upload/Dialog";
import { Il8nContext } from '../../../Helper/i18n';
import FullScreenLoader from '../../FullScreenLoader';


function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(makeAspectCrop({ unit: '%', width: 90, }, aspect, mediaWidth, mediaHeight,), mediaWidth, mediaHeight)
}

var canvasId = 0;
var screamId = 0;
var isSignatureUpload, isPAN, isAadharUpload;

function ImageUpload(props) {
  const { handleClose, onSave, image, imageArray, setSnackBar, open, selectedDocumentMasterData, deleteImage, documentUploadedDetails, uploadMessagePopup, setUploadMessagePopup, isAddressPage, setLoading,setDocUploadLoading ,setOcrUploadLoading,ocrUploadLoading,setShowFailPopup,showFailPopup,setProofs, proofType, getAllAdressData, isAddressDetails,stageDetailsResp, isObjection, uploadScreen} = props;
  const { documentName: title, documentPages: count, isMandatoryDocExpiryDate, isMandatoryDocNumber, documentTypeName, id } = selectedDocumentMasterData || {};
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const previewCanvasRef = useRef(null)
  const imgRef = useRef(null)
  const upload = useRef(null)

  const [crop, setCrop] = useState()
  const [scale, setScale] = useState(1)
  const [rotate, setRotate] = useState(0)
  const [imgArray, setImgArray] = useState([])
  const [aspect, setAspect] = useState(16 / 9)
  const [cropImage, setCropImage] = useState(false)
  const [completedCrop, setCompletedCrop] = useState()
  const [activeImageIndex, setActiveImageIndex] = useState(0)
  const [documentNumber, setDocumentNumber] = useState("")
  const [documentExpiryDate, setDocumentExpiryDate] = useState(new Date().getTime())
  const [openLivePhotoDialog, setOpenLivePhotoDialog] = useState(false)
  const [valid, setValid] = useState(true);
  const [aadharVal, setAadharVal]=useState(false)
  const localeText = useContext(Il8nContext)
  const isAadhaar = (documentTypeName=== 'Correspondence Proof Of Address' || documentTypeName === "Permanent Proof Of Address")


  const [aadharImg, setAadharImg] = useState({})
  const pattern = /[0-9]+/;

  useEffect(() => {
    if (imageArray && imageArray.length > 0) {
      setImgArray(imageArray)
      setActiveImageIndex(imageArray.length - 1)
    } else {
      setImgArray([image])
      setActiveImageIndex(0)
    }
  }, [image])

  useEffect(() => {
    if (title?.includes("Signature")) {
      isSignatureUpload = true
    } else {
      isSignatureUpload = false
    }

    if (title?.includes("PAN Card")) {
      isPAN = true
    } else {
      isPAN = false
    }

    if(title?.toLowerCase().indexOf("aadhaar") > -1){
      isAadharUpload = true
    }else{
      isAadharUpload=false
    }
  }, [])

  useEffect(()=>{
    isMandatoryDocExpiryDate && setDocumentExpiryDate(documentUploadedDetails[0]?.documentExpiryDate || new Date().getTime())
    isMandatoryDocNumber && setDocumentNumber(documentUploadedDetails[0]?.documentNumber || "")
  }, [activeImageIndex])


  useEffect(() => {
    if (title?.toLowerCase().indexOf("aadhaar") > -1) {
      if (imgArray && imgArray.length > 0 && !documentUploadedDetails[activeImageIndex]) {
        var canvas = document.createElement("canvas")
        canvas.id = "canvas" + (canvasId++)
        canvas.style.display = "none"
        document.body.appendChild(canvas)
        var img = document.createElement("img")
        img.id = "scream" + (screamId++)
        img.style.display = "none"
        img.src = imgArray[activeImageIndex]
        document.body.appendChild(img)
      }
    }
  }, [title, imgArray, activeImageIndex])


  const evtPhoto = useEventCallback((resp,isForceProceedStatus) => {
    var r = typeof resp == "string" ? JSON.parse(resp) : resp
    if (!r.responses) {
      return;
    }
    var des = r.responses[0].textAnnotations[0].description.split("\n")
    var filtered = des.filter(txt => /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/gm.test(txt))[0]
    if (!filtered){
      onSave(imgArray, activeImageIndex, documentNumber || "", documentExpiryDate || "", false,isForceProceedStatus)
      return
    }
    var ann1 = r.responses[0].textAnnotations.filter(ann => ann.description == filtered.split(" ")[0])
    var ann2 = r.responses[0].textAnnotations.filter(ann => ann.description == filtered.split(" ")[1])
    var c = document.getElementById("canvas" + (canvasId - 1));
    var ctx = c.getContext("2d");
    // ctx.canvas.width = window.innerWidth;
    // ctx.canvas.height = window.innerHeight;

    var img = document.getElementById("scream" + (screamId - 1));
    var realWidth = img.naturalWidth;
    var realHeight = img.naturalHeight;
    ctx.canvas.width = realWidth
    ctx.canvas.height = realHeight
    ctx.drawImage(img, 0, 0);
    ctx.fillStyle = '#ffffff';
    ann1.forEach(ann => {
      /*  var p = ctx.getImageData(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y, 1, 1).data; 
       var hex = "#" + ("000000" + rgbToHex(p[0], p[1], p[2])).slice(-6); */
      //ctx.fillStyle=hex
      ctx.beginPath();
      ctx.moveTo(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y);
      ctx.lineTo(ann.boundingPoly.vertices[1].x, ann.boundingPoly.vertices[1].y);
      ctx.lineTo(ann.boundingPoly.vertices[2].x, ann.boundingPoly.vertices[2].y);
      ctx.lineTo(ann.boundingPoly.vertices[3].x, ann.boundingPoly.vertices[3].y);
      ctx.closePath();
      ctx.fill();
    })
    ann2.forEach(ann => {
      ctx.beginPath();
      ctx.moveTo(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y);
      ctx.lineTo(ann.boundingPoly.vertices[1].x, ann.boundingPoly.vertices[1].y);
      ctx.lineTo(ann.boundingPoly.vertices[2].x, ann.boundingPoly.vertices[2].y);
      ctx.lineTo(ann.boundingPoly.vertices[3].x, ann.boundingPoly.vertices[3].y);
      ctx.closePath();
      ctx.fill();
    })
    let imgNew;
    c.toBlob(blob => {
      var fr = new FileReader()
      fr.onloadend = () => {
        imgNew = [...imgArray]
        imgNew[activeImageIndex] = fr.result
        setAadharImg({ ...aadharImg, [fr.result]: imgArray[activeImageIndex] })
        setImgArray(imgNew)
        setProofs({ proofType: "image", data: imgNew })
        document.body.removeChild(c)
        c.remove();
        img.remove()
        c.id = "nil"
        onSave(imgNew, activeImageIndex, documentNumber || "", documentExpiryDate || "", false, isForceProceedStatus)
      }
      fr.readAsDataURL(blob)
    })
  }, {}, [imgArray])

  function onImageLoad(event) {
    if (aspect) {
      const { width, height } = event.currentTarget
      setCrop(centerAspectCrop(width, height, aspect))
    }
  }

  useDebounceEffect(async () => {
    if (completedCrop?.width && completedCrop?.height && imgRef.current && previewCanvasRef.current) {
      canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop, scale, rotate)
    }
  }, 100, [completedCrop, scale, rotate])

  async function handleInputChange() {
    if (upload.current.files[0]) {
      let response = await onFileSelection(upload.current.files[0])
      if (response.data) {
        setActiveImageIndex(imageArray?.length || 0)
        let images = [...imgArray]
        images.push(response.data)
        setImgArray(images)
      } else {
        setSnackBar(response)
      }
    } else {
      setSnackBar({ show: true, message: localeText?.uploadValid, type: 'error' })
    }
  }

  function onImageClick(index) {
    cropImage && setCropImage(false)
    setActiveImageIndex(index)
  }

  function onImageDelete(index) {
    let imageArray = [...imgArray];
    imageArray.splice(index, 1)
    if (cropImage) {
      setRotate(0);
      setScale(1);
      previewCanvasRef.current = null;
      setCropImage(false)
    }
    setImgArray(imageArray)
    setActiveImageIndex((imageArray.length - 1) === -1 ? 0 : (imageArray.length - 1));
    deleteImage(imageArray, index)
  }

  // const isLetters = (str) => /^[a-zA-Z0-9-]+$/.test(str);

  function handleDocumentNumber(e) {
    if(title.includes("Aadhaar")){
      let reg = /^[0-9*_\-\\;':"\\,.\/?]\d{0,3}$/;
      let result = reg.test(e.target.value)
      setValid(result)
      setAadharVal(true)
      setDocumentNumber(e.target.value)
    }
    else{
      let reg = /^[a-zA-Z0-9*_\-\\;':"\\,.\/?]*$/
      let result = reg.test(e.target.value)
      setValid(result)
      setAadharVal(false)
      setDocumentNumber(e.target.value)
    }
  }

  function isInteger(value) {
    let parsedValue = parseInt(value, 10);
    return !isNaN(parsedValue) && parsedValue.toString() === value;
  }

  function verifyDocument(documentTypeName,imagesArray){
    let uploadDocName = title?.includes("Aadhaar (Masked aadhaar number)")
    let apiCallUrl = (isAadharUpload) ? config.verifyAadhar : (isPAN) ? config.verifyPAN : (isSignatureUpload) ? config.verifySignature :""
    setOcrUploadLoading(true)
    const source = axios.CancelToken.source();
     const payload = {
      "mimeType":"image/jpeg",
      "file":imagesArray[activeImageIndex].split("base64,")[1],
      "isOCR": (isObjection && isAddressDetails) ? false : isAddressDetails ? true : false
    }
    axios.post(`${process.env.REACT_APP_AARAMBHAH_URL}${apiCallUrl}`, payload,
      {
        cancelToken: source.token,
        timeout: 60000, // time in ms
      }
    ).then(response => {
        if(isAadhaar){
          if(response?.OCR?.boundingPolly && (response?.OCR?.status == true || response?.OCR?.isForceProceed == true)){
            if(isAddressDetails && response?.OCR?.isForceProceed == true || (!isObjection && isAddressDetails && !(isInteger(response?.OCR?.pincode)))){
              // evtPhoto(response?.OCR?.boundingPolly,true)
              setOcrUploadLoading(false)
              setShowFailPopup({showPopup:true,showPopupMessage:'ContactKYC'})
            }else{
              evtPhoto(response?.OCR?.boundingPolly)
            }
          }
          if(((response?.OCR?.status == true) && (response?.OCR?.isForceProceed == false)) || ((response?.OCR?.status == false) && (response?.OCR?.isForceProceed == true))) {
            setOcrUploadLoading(false)
            if (isInteger(response?.OCR?.pincode)) {
              const Data = {
                [proofType?.code?.toLowerCase()]: [
                  {
                    documentTypeCode: proofType.id,
                    documentSubType: proofType.type,
                    documentId: selectedDocumentMasterData.id || "",
                    documentScreen: proofType.screen,
                    documentName: selectedDocumentMasterData.documentName || "",
                    documentNumber: document.documentNumber,
                    documentExpiryDate: document.documentExpiryDate,
                    ocrDetails: {
                      address: response.OCR.address,
                      address_pin: response.OCR.pincode
                    }
                  }
                ]
              };
              getAllAdressData({ ...Data });
            }
          }
          else{
            setOcrUploadLoading(false)
            setShowFailPopup({showPopup:true,showPopupMessage:response?.OCR?.message || localeText.panStatusFailMessage1})
          }
        }else{
          if(((response?.OCR?.status == true) && (response?.OCR?.isForceProceed == false)) || ((response?.OCR?.status == false) && (response?.OCR?.isForceProceed == true))) {
            setOcrUploadLoading(false)
            onSave(imagesArray, activeImageIndex, documentNumber || "", documentExpiryDate || "", false)
          }
          else{
            setOcrUploadLoading(false)
            setShowFailPopup({showPopup:true,showPopupMessage:response?.OCR?.message || localeText.panStatusFailMessage1})
          }
        }
    }).catch(error => {
      console.log(error)
      setOcrUploadLoading(false)
      if(error.message){
        setShowFailPopup({showPopup:true,showPopupMessage:'ContactKYC'})
      }
      if (axios.isCancel(error)) {
        console.log('Request canceled:', error.message);
      } else if (error.code === 'ECONNABORTED') {  // timeout handling
        console.log('Request timed out');
      } else {
        console.log('Request Error:', error.message);
      }
    })
  }

  function handleSave() {
    let imagesArray = [...imgArray];
    if (imagesArray[activeImageIndex] && previewCanvasRef.current) {
      imagesArray[activeImageIndex] = previewCanvasRef.current.toDataURL();
    }
    if (isMandatoryDocNumber && (documentNumber?.toString().trim() === "")) {
      setSnackBar({ show: true, message: localeText?.uploadNoMandatory, type: 'error' })
    } else if (isMandatoryDocExpiryDate && (documentExpiryDate?.toString().trim() === "")) {
      setSnackBar({ show: true, message: localeText?.uploadDateMandatory, type: 'error' })
    } else if (isMandatoryDocExpiryDate && (documentExpiryDate < new Date().setHours(0, 0, 0, 0))) {
      setSnackBar({ show: true, message: localeText?.uploadExpiry, type: 'error' })
    } else {
      if (cropImage) {
        setRotate(0);
        setScale(1);
        previewCanvasRef.current = null;
        setCropImage(false)
      }
      if(documentTypeName=== "Proof Of Identity" || documentTypeName === "Signature"){
        imgArray && imgArray.length > 0 && !documentUploadedDetails[activeImageIndex] && verifyDocument(documentTypeName,imagesArray)
      }else if(isAadharUpload){
        imgArray && imgArray.length > 0 && verifyDocument(documentTypeName,imagesArray)
      }
      else{
        onSave(imagesArray, activeImageIndex, documentNumber || "", documentExpiryDate || "")
      }
    }
  }

  const cropper = () => {
    return (
      <Grid item md={10} lg={10} xl={10} style={classes.centerContent}>
        {
          imgArray.length > 0 ?
            cropImage ?
              <ReactCrop
                crop={crop}
                onChange={(_, percentCrop) => setCrop(percentCrop)}
                onComplete={(c) => setCompletedCrop(c)}
                aspect={undefined}
              >
                <img
                  ref={imgRef}
                  alt="Crop me"
                  src={(!imgArray[activeImageIndex]?.startsWith('data:image') ? "data:image/jpg;base64,"+imgArray[activeImageIndex] : imgArray[activeImageIndex]) || image}
                  style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
              :
              <img src={(!imgArray[activeImageIndex]?.startsWith('data:image') ? "data:image/jpg;base64,"+imgArray[activeImageIndex] : imgArray[activeImageIndex]) || image} style={{ maxWidth: "100%", maxHeight: "100%" }} />
            :
            <></>
        }
      </Grid>
    )
  }
  
  const content = () => {
    return (
      <Grid container spacing={2} style={{ height: cropImage ? "auto" : "calc(100vh - 80px)"  }}>
        {cropper()}
        <Grid item md={2} lg={2} xl={2}>
          {count && <div style={{ marginTop: '10px', marginBottom: '10px' }}>
            <span style={{ fontWeight: 600 }}>
              {`${localeText?.uploadMaximum} ${count === 1 ? `${count} ${localeText?.uploadImage}` : `${count} ${localeText?.uploadImg}`} ${localeText?.uploadUploaded}`}
            </span>
          </div>}
          <Grid container style={{ height: "auto", display: "flex", flexDirection: "column" }}>
            {
              imgArray?.length > 0 &&  imgArray?.map((img, index) => (
                <div style={{ width: '70px', height: '70px', flexDirection: 'column', margin: '12px' }}>
                  <div css={{ position: "relative" }}>
                    {
                      cropImage && index === activeImageIndex ?
                        <div style={{ width: '70px', height: '70px' }}>
                          <canvas
                            ref={previewCanvasRef || {}}
                            style={{
                              border: '1px solid black',
                              objectFit: 'contain',
                              width: '70px',
                              height: '70px',
                            }}
                          />
                        </div>
                        :
                        <img
                          onClick={() => onImageClick(index)}
                          style={{ border: activeImageIndex == index ? "2px solid #F54040" : "1px solid #707070", cursor: "pointer" }}
                          src={!img?.startsWith('data:image') ? "data:image/jpg;base64,"+img : img}
                          width={"70px"}
                          height={"70px"}
                        />
                    }
                    {
                        (documentUploadedDetails[activeImageIndex]?.documentTypeCode === 'Photo' && stageDetailsResp?.accountOpeningType?.toLowerCase() === "") 
                      || 
                        (uploadScreen && documentUploadedDetails[activeImageIndex]?.documentTypeCode === "POI" 
                          && stageDetailsResp?.isDigiPanUploaded && stageDetailsResp?.accountOpeningType?.toLowerCase() == "digi") 
                      || ((uploadScreen || stageDetailsResp?.accountOpeningType?.toLowerCase() == "digi") && documentUploadedDetails[activeImageIndex]?.documentTypeCode === "CPOA" || documentUploadedDetails[activeImageIndex]?.documentTypeCode === "PPOA")
                      ?
                      <>
                      </>

                     :
                      <div className={classes.deleteImageDiv} css={{ position: "absolute", cursor: "pointer", backgroundColor: "#24b7cc", width: "30px", height: "30px", borderRadius: "15px", bottom: "55px", left: "50px" }} onClick={() => onImageDelete(index)}>
                      <img src={"images/delete_icon.svg"} alt={"DeleteImage"} className={classes.deleteImage} css={{ padding: "4px 0px 0px 8px" }} />
                    </div>
                    } 
                  </div>
                </div>
              ))
            }
            {
              (((imgArray.length < count) && (documentUploadedDetails?.length == imgArray.length)) || imgArray.length === 0) &&
              /* props.isLivePhotoCapture && title === "Photograph & Signature" ?
              <div onClick={handleLivePhotoDialog} style={{ width: '0px', height: '0px', margin: "auto" }}>
                <img style={{ cursor: "pointer", marginTop: "20px" }} src={"images/add_icon.svg"} width={"70px"} height={"70px"} alt="" />
              </div>
              : */
              <div style={{ width: '70px', height: '70px', margin: "12px" }} onClick={() => upload.current.click()}>
                <input ref={upload} id={"uploadImage"} type="file" accept={".png, .jpg, .jpeg, .svg "} style={{ display: 'none' }} onChange={handleInputChange} />
                <img style={{ cursor: "pointer" }} src={"images/add_icon.svg"} width={"70px"} height={"70px"} alt="" />
              </div>
            }
            {/* <LivePhotoUpload imgArray={imgArray} setImgArray={setImgArray} handleLivePhotoCapture={props.handleLivePhotoCapture} handleLivePhotoDialog={handleLivePhotoDialog} openLivePhotoDialog={openLivePhotoDialog} docId={props.docMId} count={count} docName={title} /> */}
          </Grid>
          <Grid item xs={12} md={12} className={classes.center} style={{ marginBottom: '10px', position: "relative", flexWrap: "nowrap" }}>
            {
              isMandatoryDocExpiryDate && <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    inputFormat="DD/MM/YYYY"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    css={{ marginTop: "15px" }}
                    disabled={activeImageIndex!=0}
                    minDate={new Date()}
                    value={new Date(Number(documentExpiryDate))}
                    label={localeText?.uploadDocument}
                    onChange={(e) => setDocumentExpiryDate(new Date(e.$d).getTime())}
                    renderInput={(params) => <StyledTextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            }
            {
              isMandatoryDocNumber && <>
              <Grid item xs={12}>
                <StyledTextField
                  css={{ marginTop: "15px" }}
                  inputProps={{
                    pattern: pattern, // Use source property to get the string representation of the regex pattern
                    maxLength: aadharVal && 4
                  }}
                  InputLabelProps={{ shrink: true }}
                  label={localeText?.uploadDocumentNumber}
                  variant="outlined"
                  disabled={activeImageIndex!=0}
                  value={documentNumber || documentUploadedDetails[0]?.documentNumber}
                  fullWidth
                  error={!valid}
                  // helperText={(!valid && aadharVal) ? "Please enter valid last 4 digit of aadhaar" : !valid ? `Please enter valid ${title} document number` : ""}
                  onChange={(e) => handleDocumentNumber(e)}
                />
              </Grid>
              {
                <div>
                  <Typography variant="span" style={{color:'#ff0000'}}>
                    Note : {aadharVal ? "Please enter valid last 4 digit of aadhaar" : `Please enter valid ${title} document number`}
                  </Typography>
                </div>
              }
              </>
            }
            {ocrUploadLoading && <FullScreenLoader message={true} countDownTimer={true} secondsToLoad={1.7}/>}
            <Button
              onClick={handleSave}
              color="primary" variant="contained"
              style={{ margin: "15px 0px 10px 0px" }}
              disabled={documentUploadedDetails[activeImageIndex] || imgArray.length === 0 || !valid || aadharVal ? documentNumber?.length !== 4 : false}>
              {localeText?.uploadSaveBtn}
            </Button>
            {
              isSignatureUpload &&
              <Grid sx={{backgroundColor:'#E5F3FE', border:'1px solid #E5F3FE', borderRadius:'10px', padding:'10px 10px 15px 10px'}}>
              <Grid item xs={12}>
                <Typography style={{ fontWeight: 600 }}>
                  {localeText?.uploadInfo}
                </Typography>
                <ol style={{margin:0, paddingX:'0px'}}>
                  <li style={{ fontWeight: 600 }}>{localeText?.uploadSignNote1}</li>
                  <li style={{ fontWeight: 600 }}>{localeText?.uploadSignNote2}</li>
                </ol>
              </Grid>
              </Grid>
            }
            {
              isPAN &&
              <Grid sx={{backgroundColor:'#E5F3FE', border:'1px solid #E5F3FE', borderRadius:'10px', padding:'10px 10px 15px 10px'}}>
              <Grid item xs={12} >
                <Typography style={{ fontWeight: 600 }}>
                  {localeText?.uploadInfo}
                </Typography>
                <ol style={{margin:0,paddingX:'0px'}}>
                  <li style={{ fontWeight: 600 }}>{localeText?.uploadPANNote1}</li>
                  <li style={{ fontWeight: 600 }}>{localeText?.uploadPANNote2}</li>
                  <li style={{ fontWeight: 600 }}>{localeText?.uploadPANNote3}</li>
                </ol>
              </Grid>
              {
                !isSmallScreen && 
                <Grid sx={{display:'flex', flexDirection:'column', justifyContent:'space-between', alignItems:'start', paddingTop:'15px'}}>
              <Typography style={{ fontWeight: 600 }}>
                {localeText?.uploadSample} :
              </Typography>
              <img src="images/pan-2.png" alt="Pancard" className="" width="150" height="90" style={{paddingTop:'10px'}}/>
            </Grid>
              }
                </Grid>
            }
            {
              isAadharUpload &&
              <Grid sx={{backgroundColor:'#E5F3FE', border:'1px solid #E5F3FE', borderRadius:'10px', padding:'10px 20px 15px 10px'}}>
              <Grid item xs={12}>            
                <Typography style={{ fontWeight: 600 }}>
                {localeText?.AddressGuidelines}
                </Typography>
                <ol style={{margin:0, paddingX:'0px'}}>
                  <li style={{ fontWeight: 600 }}>{localeText?.AddressGuideline1}</li>
                  <li style={{ fontWeight: 600 }}>{localeText?.AddressGuideline2}</li>
                  <li style={{ fontWeight: 600 }}>{localeText?.AddressGuideline3}</li>
                </ol>
              </Grid>
              </Grid>
            }
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Dialog open={open} handleClose={handleClose} fullWidth={false} maxWidth='md'>
        <DialogTitle
          scale={scale}
          title={title}
          rotate={rotate}
          imgArray={imgArray || []}
          cropImage={cropImage}
          setCropImage={setCropImage}
          setRotate={(rotate) => setRotate(rotate)}
          setScale={(scale) => setScale(scale)}
          onClose={() => handleClose(imgArray)}
        />
        <DialogContent style={matches ? {} : { height: "calc(100vh - 90px)", flex: "none", padding: '8px 16px' }}>
          {content()}
        </DialogContent>
      </Dialog>
      <ConfirmationPopup
        open={uploadMessagePopup}
        showOptions={documentUploadedDetails?.length < count}
        onConfirm={() => { setUploadMessagePopup(false) }}
        onClose={() => { setUploadMessagePopup(false); handleClose(imgArray) }}
      />
    </>
  )
}

export default ImageUpload;